import { Injectable } from '@angular/core';

import _set from 'lodash-es/set';
import _unset from 'lodash-es/unset';
import _trimEnd from 'lodash-es/trimEnd';

import { ConfigurationResourceService } from 'libraries/service/resources/configuration/configurationResource.service';
import { Observable } from 'rxjs';

@Injectable()
export class SSRService {

  public response: any = { data: {}, selected:{}, pnr:[] };
  private m_url=sessionStorage.getItem('$wui_url')+"shared_air/config/ssr/ssrConfig.json";
  constructor (private configResource: ConfigurationResourceService) {}

  public getSSRListStream(): Observable<any>{
    return this.configResource.get(["wui", "shared_air", "config", "ssr", "ssrConfig.json"]);
  }
  /**
  * get SSR Datas from json File
  **/
  public getSSRList() {
      this.getSSRListStream()
        .subscribe((result: any) => {
            this.storeResult(result);
        },
        (error:any): any => {});
  }

  /*
  * storeSSR choosen from UI, ssr.component -> search.component
  */
  public selectSSR(travellerItem: string, ssrkey: string, textValue:any): void{
      const text="";
      const typeKeys = Object.keys(this.response.data);
      const separator = "/";

      if(this.isMeal(ssrkey)){
          this.response.selected[travellerItem + ssrkey] = {"traveller":travellerItem, "code":ssrkey};
          _set(this.response, ['decodedSsr', travellerItem, 'traveller'],    travellerItem);
          _unset(this.response, ['decodedSsr', travellerItem, 'meal']);
          _set(this.response, ['decodedSsr', travellerItem, 'meal', ssrkey], true);
      }

      if(this.isLuggage(ssrkey)){

        let text:string;
        let i=0;

        text = ssrkey;
        text += separator;
        const data: any={};
        for(const fieldkey of Object.keys(this.response.data.luggage[ssrkey].text.field)){

            // if label.insert == true, concat the label
            if(this.response.data.luggage[ssrkey].text.field[fieldkey].label.insert){
                text += fieldkey;
            }

            //insert value from interface
            //XXX: find a way to use carrier default if no changes from interface
            text += textValue[fieldkey];

            // if unit is set, insert it
            if(this.response.data.luggage[ssrkey].text.field[fieldkey].unit){
                text += this.response.data.luggage[ssrkey].text.field[fieldkey].unit;
            }

            if(i < Object.keys(this.response.data.luggage[ssrkey].text.field).length){
              text += separator;
            }

            _set(data, 'code', ssrkey);
            _set(data, fieldkey, textValue[fieldkey]);

            i++;

        }

        // if there is a separator at the end, remove it
        text = _trimEnd(text, separator);

        this.response.selected[travellerItem + ssrkey] = {"traveller":travellerItem, "code":"SPEQ", "text": text};
        _set(this.response, ['decodedSsr', travellerItem, 'traveller'],    travellerItem);
        _unset(this.response, ['decodedSsr', travellerItem, 'luggage']);
        _set(this.response, ['decodedSsr', travellerItem, 'luggage', ssrkey], data);

      }

  }

  /*
  * unstoreSSR choosen from UI, ssr.component -> locobook.component
  */
  public unselectSSR(travellerItem: string, ssrkey: string): void{
    delete this.response.selected[travellerItem + ssrkey];

    _unset(this.response, ['selected', travellerItem + ssrkey]);
    _set(this.response, ['decodedSsr', travellerItem, 'traveller'], travellerItem);

    if(this.isMeal(ssrkey)){
        _unset(this.response, ['decodedSsr', travellerItem, 'meal']);
    }else if (this.isLuggage(ssrkey)){
        _unset(this.response, ['decodedSsr', travellerItem, 'luggage', ssrkey]);
    }
  }

  /*
  * store results after getSSRList()
  */
  private storeResult(res: any) {
      this.response.data=res;
  }

  private isMeal(ssrkey: string): boolean{
    return Boolean(this.response.data.meal[ssrkey]);
  }

  private isLuggage(ssrkey: string): boolean{
    return !this.isMeal(ssrkey);
  }
}
